export const isEllipsisActive = e => {
  return e?.offsetWidth < e?.scrollWidth
}
